// create vehicle

export const CREATE_VEHICLE_REQUEST = 'CREATE_VEHICLE_REQUEST';
export const CREATE_VEHICLE_SUCCESS = 'CREATE_VEHICLE_SUCCESS';
export const CREATE_VEHICLE_FAIL = 'CREATE_VEHICLE_FAIL';
export const CLEAR_CREATE_VEHICLE_STATE = 'CLEAR_CREATE_VEHICLE_STATE';

// Update vehicle

export const UPDATE_VEHICLE_REQUEST = 'UPDATE_VEHICLE_REQUEST';
export const UPDATE_VEHICLE_SUCCESS = 'UPDATE_VEHICLE_SUCCESS';
export const UPDATE_VEHICLE_FAIL = 'UPDATE_VEHICLE_FAIL';

// delete vehicle

export const DELETE_VEHICLE_REQUEST = 'DELETE_VEHICLE_REQUEST';
export const DELETE_VEHICLE_SUCCESS = 'DELETE_VEHICLE_SUCCESS';
export const DELETE_VEHICLE_FAIL = 'DELETE_VEHICLE_FAIL';

export const CLEAR_UPDATE_VEHICLE_STATE = 'CLEAR_UPDATE_VEHICLE_STATE';
export const CLEAR_DELETE_VEHICLE_STATE = 'CLEAR_DELETE_VEHICLE_STATE';

export const UPDATE_VEHICLES_LISTING = 'UPDATE_VEHICLES_LISTING';

export const GET_VEHICLE_LISTING_REQUEST = 'GET_VEHICLE_LISTING_REQUEST';
export const GET_VEHICLE_LISTING_SUCCESS = 'GET_VEHICLE_LISTING_SUCCESS';
export const GET_VEHICLE_LISTING_FAIL = 'GET_VEHICLE_LISTING_FAIL';

export const GET_VEHICLE_REQUEST = 'GET_VEHICLE_REQUEST';
export const GET_VEHICLE_SUCCESS = 'GET_VEHICLE_SUCCESS';
export const GET_VEHICLE_FAIL = 'GET_VEHICLE_FAIL';
export const CLEAR_GET_VEHICLE_STATE = 'CLEAR_GET_VEHICLE_STATE';

// Export vehicle

export const EXPORT_VEHICLE_REQUEST = 'EXPORT_VEHICLE_REQUEST';
export const EXPORT_VEHICLE_SUCCESS = 'EXPORT_VEHICLE_SUCCESS';
export const EXPORT_VEHICLE_FAIL = 'EXPORT_VEHICLE_FAIL';
export const CLEAR_EXPORT_VEHICLE_STATE = 'CLEAR_EXPORT_VEHICLE_STATE';

export const UPDATE_VEHICLE_IMAGES = 'UPDATE_VEHICLE_IMAGES';

// search vehicle

export const SEARCH_VEHICLE_REQUEST = 'SEARCH_VEHICLE_REQUEST';
export const SEARCH_VEHICLE_SUCCESS = 'SEARCH_VEHICLE_SUCCESS';
export const SEARCH_VEHICLE_FAIL = 'SEARCH_VEHICLE_FAIL';
export const CLEAR_SEARCH_VEHICLE_STATE = 'CLEAR_SEARCH_VEHICLE_STATE';

// import vehicles

export const IMPORT_VEHICLE_REQUEST = 'IMPORT_VEHICLE_REQUEST';
export const IMPORT_VEHICLE_SUCCESS = 'IMPORT_VEHICLE_SUCCESS';
export const IMPORT_VEHICLE_FAIL = 'IMPORT_VEHICLE_FAIL';

// clear import sate
export const CLEAR_IMPORT_VEHICLE_STATE = 'CLEAR_IMPORT_VEHICLE_STATE';
